import { Input, type InputProps } from 'components/ui/input';
import { FC } from 'react';
import { debounce } from 'utils/debounce';

interface DebouncedSearchInputProps extends InputProps {
  onDebouncedChange: (searchTerm: string) => void;
}

export const SearchInputDebounce: FC<DebouncedSearchInputProps> = ({
  onDebouncedChange: rebound,
  ...otherProps
}) => {
  const debounceSearch: React.ChangeEventHandler<HTMLInputElement> = (e) => {
    rebound(e.target.value);
  };

  return (
    <Input
      data-testid="debounce-input"
      {...otherProps}
      onChange={debounce(debounceSearch)}
    />
  );
};
